export default "__VITE_ASSET__y4Enn1ppqbFiD7shn9d2Iw__";